<template>
	<div>
		<div v-if="state">
			<div
				v-if="currentItem || (!currentItem && state !== '3')"
				:class="state === '1' ? 'pass-state' : state === '2' ? 'back-state' : 'trans-state'">
				<i
					v-if="state === '1' || state === '2'"
					:class="state === '1' ? 'el-icon-circle-check' : 'el-icon-refresh-left'">
				</i>
				<span> {{ state === '1' ? '通过' : state === '2' ? '驳回' : '转'}}</span>
			</div>
			<span v-if="state === '3' && currentItem">{{ getTransPerson() }}</span>
			<span v-if="state === '3' && !currentItem" class="hasTrans-state">已转交</span>
		</div>
		<span v-if="!state && !isMotherType">
			<div v-if="currentItem.cc && data.status === '2'" class="back-state">已抄送</div>
			<span v-else>{{ currentItem.cc ? '未抄送' : '未审批' }}</span>
		</span>
	</div>
</template>

<script>
export default {
	name: 'activityLogState',

	props: {
		isMotherType: {
			type: Boolean,
			default: false
		},
		state: {
			type: String,
			default: ''
		},
		data: {
			type: Object
		},
		currentItem: {
			type: Object
		}
	},

	components:{},

	data () {
		return {
		}
	},

	methods: {
		getTransPerson() {
			const id = this.currentItem.id;
			return this.data.childList.find(item => item.lastnode === id).approvalusename;
		}
	},

	computed: {},

	mounted(){
	}
}
</script>

<style lang="scss">
@mixin state {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	margin-right: 10px;
	width: 50px;
	height: 22px;
	background-color: #fff;
	border-radius: 4px;
	font-size: 12px;

	& span {
		display: inline-block;
		margin-left: 3px;
	}
}

.pass-state {
	@include state;
	border: 1px solid rgb(12, 189, 12);
	color: rgb(12, 189, 12);
}

.back-state {
	@include state;
	border: 1px solid #faad14;
	color: #faad14;
}

.trans-state {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	margin-right: 10px;
	width: 22px;
	height: 22px;
	border-radius: 11px;
	color: #fff;
	background-color: #108cee;
}

.hasTrans-state {
	@include state;
	border: 1px solid #108cee;
	color: #108cee;
}
</style>